<ccl-navbar-primary productTitle="Session Catalog Designer" route="admin"></ccl-navbar-primary>
<ccl-navbar-secondary></ccl-navbar-secondary>
<router-outlet></router-outlet>
<ccl-navbar-footer></ccl-navbar-footer>

<ng-template #navbarItemTitleCustom let-item>
    <span class="c-title c-title--{{item.itemStyle}}" title="{{item.alt}}">
        {{item.label}}
    </span>
</ng-template>
<ng-template #navbarItemExternalLinkCustom let-item>
    <a href="javascript:void(0)" (click)="sendMessage(item.message)" [class]="item.itemStyle">
        <span>{{item.label}}</span>
        <i class="fa fa-lg fa-external-link"></i>
    </a>
</ng-template>